// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"g_m","imageContainer":"g_n","image":"g_p","captionContainer":"g_q","arrow":"g_r","left":"g_s","arrowIcon":"g_t","right":"g_v"};